var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoInterviews({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.142 85.529C80.3814 94.4147 68.8977 102.34 56.8167 109.217C53.5617 111.486 49.8981 113.069 46.0395 113.873C41.6271 114.255 37.2059 113.242 33.3712 110.971C33.3712 110.971 33.2175 110.971 33.1736 110.837C32.1415 110.319 31.1314 109.734 30.1213 109.127C19.1418 102.378 9.45625 92.4802 5.34577 80.0176C4.60597 77.7277 4.04704 75.3806 3.67439 72.999C3.67439 72.999 3.67439 72.999 3.67439 72.999C2.67948 66.1162 3.10283 59.0968 4.91715 52.3931C7.46438 43.3446 11.8611 34.9555 17.8155 27.783C24.7801 18.7104 34.1997 11.9425 44.8979 8.32439C49.0761 7.01484 53.4144 6.31806 57.7837 6.2548C70.9557 6.07483 84.2834 10.9789 95.9873 17.5026C98.2516 18.7318 100.451 20.0834 102.575 21.5518C106.477 24.0712 109.9 27.2953 112.678 31.0674C125.858 50.301 104.814 73.5614 91.142 85.529Z",
    fill: "#F4F4F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5079 27.7902L99.5427 26.7227C99.5427 26.7227 99.6977 54.5194 99.5427 65.3254C99.3882 76.1268 100.625 98.7888 100.625 98.7888C100.625 98.7888 70.0304 96.7917 59.3114 96.7917C48.5925 96.7917 21.8628 96.5537 21.8628 96.5537C21.8628 96.5537 24.9719 92.0505 24.6629 68.8625C24.3534 45.669 24.5079 27.7902 24.5079 27.7902Z",
    fill: "#F4F4F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.292 26.7197L100.345 39.9307L100.348 40.6699L99.6084 40.6836L99.5947 39.9336L99.6074 40.6836H99.5928C99.5827 40.6838 99.5677 40.6842 99.5479 40.6846C99.5078 40.6853 99.4476 40.6861 99.3691 40.6875C99.2123 40.6903 98.9805 40.6949 98.6807 40.7002C98.0809 40.7107 97.2088 40.7257 96.1191 40.7441C93.9396 40.7811 90.8895 40.8311 87.4072 40.8838C82.1842 40.9628 75.9871 41.0477 70.2969 41.1025L64.8301 41.1465C57.9069 41.19 47.8115 41.0738 39.4521 40.9473C35.2717 40.884 31.5235 40.8187 28.8203 40.7686C27.469 40.7435 26.3785 40.7219 25.626 40.707C25.2498 40.6996 24.9575 40.6935 24.7598 40.6895C24.6611 40.6875 24.5858 40.6866 24.5352 40.6855C24.5099 40.685 24.4904 40.6839 24.4775 40.6836H24.458L23.7217 40.668L23.7236 39.9316L23.7578 27.7881L23.7598 27.0508L24.4971 27.04L99.5322 25.9727L100.289 25.9619L100.292 26.7197Z",
    fill: "white",
    stroke: "#70758F",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5428 65.3262C99.3883 76.1276 100.625 98.7896 100.625 98.7896C100.625 98.7896 70.0305 96.7925 59.3115 96.7925",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2133 44.3818C19.6978 51.8897 19.8528 75.4262 19.5433 82.023C19.2338 88.6198 19.4233 90.3373 19.5433 92.4994C19.6633 94.68 19.3888 96.1091 19.3888 96.1091H22.1029",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1903 46.7803H92.276V88.3196L30.2798 87.289L31.1903 46.7803Z",
    fill: "white",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9668 56.3994H92.276",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.876 66.127C30.876 66.127 65.3276 66.2431 91.8786 66.627",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5039 77.0317C30.5039 77.0317 45.6721 78.1998 56.271 78.4243C66.87 78.6443 92.2766 78.4243 92.2766 78.4243",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40.625 53.75C40.625 53.75 40.625 64.5402 40.625 73.3349C40.625 82.1259 40.625 87.5 40.625 87.5",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.375 46.7803V87.4586",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.377 46.6265V87.6283",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3774 46.6265V87.6283",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.875 46.875L82.5 79.375",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3931 31.1204C93.6506 31.0334 93.8741 30.9324 94.1146 30.8274C96.5367 29.5903 98.2028 24.7671 94.9906 21.8625C91.7785 18.9584 86.5048 21.3815 86.8138 26.8787",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2783 39.249C22.2783 39.249 22.4663 45.9048 22.8273 59.6474C23.1878 73.39 20.8027 94.3609 20.8027 94.3609",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1172 31.1204C78.3747 31.0334 78.5982 30.9324 78.8387 30.8274C81.2608 29.5903 82.9269 24.7671 79.7148 21.8625C76.5026 18.9584 71.2289 21.3815 71.5379 26.8787",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5815 31.1204C63.8391 31.0334 64.0626 30.9324 64.3031 30.8274C66.7252 29.5903 68.3912 24.7671 65.1791 21.8625C61.967 18.9584 56.6932 21.3815 57.0023 26.8787",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8828 31.263C49.1403 31.176 49.3638 31.075 49.6043 30.97C52.0264 29.7329 53.6925 24.9097 50.4804 22.0051C47.2682 19.1009 41.9945 21.524 42.3035 27.0213",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2803 31.263C34.5378 31.176 34.7613 31.075 35.0018 30.97C37.4239 29.7329 39.09 24.9097 35.8778 22.0051C32.6657 19.1009 27.392 21.524 27.701 27.0213",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0478 64.627H73.3775L73.1454 78.1275H62.3836L61.377 77.641L62.0478 64.627Z",
    fill: "#F4F4F5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.874 69.627L64.8774 71.363",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1651 69.8906C68.1136 69.9226 65.1245 75.4749 65.1245 75.4749",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9304 71.1226L67.2163 75.4377",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6141 78.0342L62.0519 78.0267C61.9304 78.0267 61.8108 77.9997 61.7008 77.9487C61.3958 77.8071 61.2058 77.4966 61.2178 77.1606L61.4328 71.1934",
    stroke: "#70758F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInterviews);
export default __webpack_public_path__ + "static/media/no-interviews.06091c5cb0ae34f6c008444b14b88284.svg";
export { ForwardRef as ReactComponent };